import React, { useState } from "react";
import { IconButton, TableCell, TableRow, Tooltip } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import LockIcon from '@material-ui/icons/Lock';

const contractBadgeStyle = {
	Active: { background: '#d1fae5', color: '#065f46' },
	'On Hold': { background: '#fef3c7', color: '#92400e' },
	Terminated: { background: '#fee2e2', color: '#991b1b' },
	Closed: { background: '#f3f4f6', color: '#4b5563' },
};

const ContractBadges = ({ statuses }) => (
	<>
		{(statuses || []).map(cs => {
			const label = typeof cs === 'object' ? (cs?.contract_status || cs?.name || '') : (cs || '');
			return (
				<span
					key={label}
					style={{
						...contractBadgeStyle[label],
						borderRadius: 4,
						padding: '2px 8px',
						fontSize: 11,
						fontWeight: 600,
						marginRight: 4,
						display: 'inline-block',
					}}
				>
					{label}
				</span>
			);
		})}
	</>
);

function AssetStatusList({ item, onDelete, onEditFn, onViewFn }) {
	const subStatuses = Array.isArray(item?.sub_statuses) ? item.sub_statuses : [];
	const contractStatuses = Array.isArray(item?.contract_statuses) ? item.contract_statuses : [];
	const isArchive = item?.is_system_default;
	const resolveUser = (val) => {
		if (!val) return '--';
		if (typeof val === 'string') return val;
		return val?.name || val?.first_name || '--';
	};
	const createdBy = resolveUser(item?.created_by);
	const updatedBy = resolveUser(item?.updated_by);

	const [lessMore, setLessMore] = useState({});
	const toggleLessMore = (lessMr) => {
		setLessMore({
			...lessMore,
			[lessMr]: !lessMore[lessMr]
		});
	}
	const lessMoreFn = (name, lessMr) => {
		return <>
			{name && name?.length > 35 ? (
				<>
					{lessMore[lessMr] ?
						(<> {name} <span style={{ color: "#0e7fe1", cursor: 'pointer' }} onClick={(e) => { e.preventDefault(); toggleLessMore(lessMr); }}  > ..less </span> </>)
						:
						(<>{name?.substring(0, 35)} <span style={{ color: "#0e7fe1", cursor: 'pointer' }} onClick={(e) => { e.preventDefault(); toggleLessMore(lessMr); }}  > ..more </span> </>)
					}
				</>
			) : name || '--'
			}
		</>
	}

	const actions = (
		<div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
			<Tooltip title="View">
				<IconButton size="small" onClick={onViewFn}>
					<VisibilityIcon style={{ fontSize: 16, color: '#5c6bc0' }} />
				</IconButton>
			</Tooltip>
			<Tooltip title="Edit">
				<IconButton size="small" onClick={onEditFn}>
					<EditIcon style={{ fontSize: 16, color: '#3f51b5' }} />
				</IconButton>
			</Tooltip>
			<Tooltip title="Delete">
				<IconButton size="small" onClick={() => onDelete({ modal: true, data: item })}>
					<DeleteOutlineIcon style={{ fontSize: 16, color: '#d32f2f' }} />
				</IconButton>
			</Tooltip>
		</div>
	);

	if (isArchive) {
		return (
			<TableRow style={{ background: '#f9f9fb' }}>
				<TableCell style={{ verticalAlign: 'top', textAlign: 'left' }}>
					<div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
						<Tooltip title="View">
							<IconButton size="small" onClick={onViewFn}>
								<VisibilityIcon style={{ fontSize: 16, color: '#5c6bc0' }} />
							</IconButton>
						</Tooltip>
						<Tooltip title="System default — cannot be edited or deleted">
							<span style={{ display: 'flex', alignItems: 'center' }}>
								<LockIcon style={{ fontSize: 16, color: '#aaa' }} />
							</span>
						</Tooltip>
					</div>
				</TableCell>
				<TableCell style={{ color: '#6b7280', verticalAlign: 'top', textAlign: 'left' }}><span style={{ fontWeight: 600 }}>{item?.ownership}</span></TableCell>
				<TableCell style={{ verticalAlign: 'top', textAlign: 'left' }}>
					<span style={{ color: '#6b7280', fontStyle: 'italic' }}>
						{item?.asset_status}&nbsp;
						<span style={{ background: '#e5e7eb', borderRadius: 3, padding: '1px 6px', fontSize: 10, color: '#374151', fontStyle: 'normal', fontWeight: 600 }}>
							SYSTEM
						</span>
					</span>
				</TableCell>
				<TableCell style={{ color: '#aaa', fontStyle: 'italic', verticalAlign: 'top', textAlign: 'left' }}>N/A</TableCell>
				<TableCell style={{ color: '#aaa', fontStyle: 'italic', verticalAlign: 'top', textAlign: 'left' }}>N/A</TableCell>
				<TableCell style={{ color: '#6b7280', verticalAlign: 'top', textAlign: 'left' }}>{createdBy}</TableCell>
				<TableCell style={{ color: '#6b7280', verticalAlign: 'top', textAlign: 'left' }}>{updatedBy}</TableCell>
				<TableCell style={{ color: '#6b7280', minWidth: "140px", maxWidth: "200px", wordBreak: 'break-word', whiteSpace: 'normal', verticalAlign: 'top', textAlign: 'left' }}>{item?.remarks || '--'}</TableCell>
			</TableRow>
		);
	}

	const cellBase = { verticalAlign: 'top', textAlign: 'left' };
	const remarksCellStyle = { minWidth: "140px", maxWidth: "200px", wordBreak: 'break-word', whiteSpace: 'normal', verticalAlign: 'top', textAlign: 'left' };

	if (!subStatuses.length) {
		return (
			<TableRow hover>
				<TableCell style={{ ...cellBase, minWidth: "120px" }}>{actions}</TableCell>
				<TableCell style={{ ...cellBase, minWidth: "120px" }}><span style={{ fontWeight: 600 }}>{item?.ownership}</span></TableCell>
				<TableCell style={{ ...cellBase, minWidth: "120px" }}><span style={{ fontWeight: 500 }}>{item?.asset_status}</span></TableCell>
				<TableCell style={cellBase}>--</TableCell>
				<TableCell style={cellBase}><ContractBadges statuses={contractStatuses} /></TableCell>
				<TableCell style={{ ...cellBase, minWidth: "110px" }}>{createdBy}</TableCell>
				<TableCell style={{ ...cellBase, minWidth: "120px" }}>{updatedBy}</TableCell>
				<TableCell style={remarksCellStyle}>{lessMoreFn(item?.remarks, 'remarks_0')}</TableCell>
			</TableRow>
		);
	}

	return (
		<>
			{subStatuses?.map((sub, idx) => {
				const subLabel = typeof sub === 'object' ? (sub?.sub_status || sub?.name || '') : (sub || '');
				return (
					<TableRow key={idx} hover>
						<TableCell style={{ ...cellBase, minWidth: "120px" }}>{idx === 0 ? actions : ''}</TableCell>
						<TableCell style={{ ...cellBase, minWidth: "130px" }}>{idx === 0 ? <span style={{ fontWeight: 600 }}>{item?.ownership}</span> : ''}</TableCell>
						<TableCell style={{ ...cellBase, minWidth: "120px" }}>{idx === 0 ? <span style={{ fontWeight: 500 }}>{item?.asset_status}</span> : ''}</TableCell>
						<TableCell style={{ ...cellBase, }}>{subLabel}</TableCell>
						<TableCell style={cellBase}>{idx === 0 ? <ContractBadges statuses={contractStatuses} /> : ''}</TableCell>
						<TableCell style={{ ...cellBase, minWidth: "110px" }}>{idx === 0 ? createdBy : ''}</TableCell>
						<TableCell style={{ ...cellBase, minWidth: "120px" }}>{idx === 0 ? updatedBy : ''}</TableCell>
						<TableCell style={remarksCellStyle}>
							{idx === 0 ? lessMoreFn(item?.remarks, `remarks_${idx}`) : ''}
						</TableCell>
					</TableRow>
				);
			})}
		</>
	);
}

export default AssetStatusList;
